import React from "react";
import "./banner.css"

export default function Banner(){
    return(
        <div className="banner" >
            <h3>Just Beacuse You Care For Someone</h3><h3>We are On SALE
                </h3>
            <h3>And</h3>
            <h3>Everything is FREE!</h3>
        </div>
    )
}